import { showSuccess } from '@calendly/alert'
import { I18n } from '@calendly/i18n'

import { rootApi } from 'root-api'

const api = rootApi.injectEndpoints({
  tagTypes: ['PaymentsSettings'],
  endpoints: (build) => ({
    getPaymentsSettings: build.query({
      query: () => ({
        url: '/api/payments_settings/show_user_settings'
      }),
      providesTags: ['PaymentsSettings']
    }),
    updateOrganizationPaymentsSettings: build.mutation({
      query: ({ paymentsDisabledByAdmin }) => ({
        url: '/api/payments_settings/update_organization_settings',
        method: 'POST',
        data: { paymentsDisabledByAdmin }
      }),
      invalidatesTags: ['PaymentsSettings'],
      extraOptions: {
        onSuccess: (_, { dispatch }) => dispatch(showSuccess(I18n.t('publisher.flash.settings_saved')))
      }
    })
  })
})

export const {
  useGetPaymentsSettingsQuery,
  useUpdateOrganizationPaymentsSettingsMutation
} = api
